import React, { Component } from 'react';
import { connect } from 'react-redux';
import Recirculation from '../common/Recirculation';
import { getRecirculationData } from '../../utils';
import './404.scss';

class NotFoundView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    getRecirculationData()
      .then((articles) => {
        if (articles.length > 0) {
          this.setState({ 
            articles 
          });
        }
      });
  }

  render() {
    const { isMobile } = this.props;
    const { articles } = this.state;

    return (
      <div>
        <div className="not-found">
          <div className="not-found-copy">
            <p className="not-found-copy-top">Something Went Wrong.</p>
            <p className="not-found-copy-bottom">(Mercury must be in retrograde.)</p>
          </div>
          <div className="not-found-img-container">
            <img className="not-found-img" src={`https://www.purewow.com/static-gmg/purewow/images/404-${isMobile ? 'mobile' : 'desktop'}.jpeg`} alt="404 image that says OOPS spelled with planets" />
          </div>
          <div className="not-found-more-stories">
            <p>Can We Interest You in Some Of These Stories Instead?</p>
          </div>
          <div className="not-found-hr"></div>
        </div>
        <div className="grid-container">
        <Recirculation articles={articles} isMobile={isMobile} />
        </div>
      </div>
    );
  }
}

const mapState = ({ isMobile }) => {
  return {
    isMobile
  }
};

const NotFound = connect(mapState)(NotFoundView);

export default NotFound;

